<template>
  <section v-loading="listLoading" class="page-container">
    <!--工具条-->
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.id" placeholder="ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.userId" placeholder="UserID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.orderNo" placeholder="OrderNO"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.sku" placeholder="SKU"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.status" placeholder="Status" clearable>
            <el-option v-for="s in statusList" :key="s.status" :value="s.status" :label="s.cn" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.deleted" placeholder="Deleted?" clearable>
            <el-option :value="false" label="NO" />
            <el-option :value="true" label="YES" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.official" placeholder="Official Order" clearable>
            <el-option :value="true" label="YES" />
            <el-option :value="false" label="NO" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="filters.timeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="Begin time"
            end-placeholder="End time"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="showImport">导入</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--列表-->
    <el-table
      ref="dataTable"
      :data="results"
      highlight-current-row
      stripe
      border
      :height="tableHeight"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <div class="expand-info">
            <el-descriptions v-if="props.row.user" title="用户信息" :column="4" size="small" border>
              <el-descriptions-item label="用户ID">{{
                props.row.user.userId
              }}</el-descriptions-item>
              <el-descriptions-item label="昵称">{{
                props.row.user.nickname
              }}</el-descriptions-item>
              <el-descriptions-item label="头像">
                <avatar :user="props.row.user" />
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="orderNo" label="订单号"></el-table-column>
      <el-table-column prop="userId" label="用户ID"></el-table-column>
      <el-table-column prop="productSku" label="款号"></el-table-column>
      <el-table-column prop="productId" label="商品ID"></el-table-column>
      <el-table-column prop="size" label="尺码"></el-table-column>
      <el-table-column prop="productName" label="商品名"></el-table-column>
      <el-table-column prop="productImage" label="图片">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.productImage"
            :preview-src-list="[scope.row.productImage]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="productItemType" label="类型">
        <template #default="{ row }">
          {{ productItemTypes[row.productItemType] || row.productItemType }}
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格"></el-table-column>
      <el-table-column prop="rateFee" label="手续费"></el-table-column>
      <el-table-column prop="techFee" label="技术支持费"></el-table-column>
      <el-table-column prop="deposit" label="保证金"></el-table-column>
      <el-table-column prop="totalFee" label="总费用"></el-table-column>
      <el-table-column prop="statusStr" label="状态"></el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-dropdown type="primary" @command="handleCommand">
            <el-button type="primary" size="mini">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="{ type: 'paymentOrder', index: scope.$index, data: scope.row }"
                >支付记录</el-dropdown-item
              >
              <el-dropdown-item
                :command="{ type: 'updatePrice', index: scope.$index, data: scope.row }"
                >修改价格</el-dropdown-item
              >
              <el-dropdown-item
                :command="{ type: 'showUpdateRecord', index: scope.$index, data: scope.row }"
                >操作记录</el-dropdown-item
              >
              <el-dropdown-item
                :command="{ type: 'updateStatus', index: scope.$index, data: scope.row }"
                >更新状态</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form :key="editFormKey" ref="editForm" :model="editForm" label-width="80px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="价格">
          <el-input v-model="editForm.price"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!-- 修改状态 -->
    <el-dialog title="修改状态" :visible.sync="updateStatusVisible" :close-on-click-modal="false">
      <el-form
        :key="updateStatusFormKey"
        ref="updateStatusForm"
        :model="updateStatusForm"
        label-width="80px"
      >
        <el-input v-model="updateStatusForm.id" type="hidden"></el-input>
        <el-form-item label="状态">
          <el-select v-model="updateStatusForm.status" placeholder="状态" clearable>
            <el-option v-for="s in statusList" :key="s.status" :value="s.status" :label="s.cn" />
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="updateStatusForm.memo" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="updateStatusForm.statusOption" @change="updateStatusOptionsChange">
            <el-option
              v-for="(o, i) in updateStatusOptions"
              :key="i"
              :value="o.value"
              :label="o.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="图片">
          <image-upload v-model="updateStatusForm.image" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="updateStatusVisible = false">取消</el-button>
        <el-button type="primary" :loading="updateStatusLoading" @click.native="updateStatus"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog
      title="导入"
      :visible.sync="importFormVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-upload
        ref="import"
        drag
        :action="importActionUrl"
        :auto-upload="false"
        :headers="uploadHeaders"
        :on-error="submitImportError"
        :on-success="submitImportSuccess"
        with-credentials
        name="file"
        accept="application/vnd.ms-excel"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传xls文件</div>
      </el-upload>
      <div slot="footer" v-loading="importLoading" class="dialog-footer">
        <el-button @click.native="importFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="importLoading" @click.native="submitImport"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <order-update-record ref="updateRecord" :type="2" />
    <payment-order-dialog ref="paymentOrderDialog" />
  </section>
</template>

<script>
import Avatar from "@/components/Avatar";
import ImageUpload from "@/components/ImageUpload";
import MyPagination from "@/components/MyPagination";
import { getToken } from "@/utils/auth";
import { getLocale } from "@/utils/locale";
import PaymentOrderDialog from "../../payment-order/PaymentOrderDialog";
import OrderUpdateRecord from "../order-update-record/index";
export default {
  name: "SellerOrder",
  components: { MyPagination, Avatar, ImageUpload, OrderUpdateRecord, PaymentOrderDialog },
  data() {
    return {
      tableHeight: 700,
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      editFormKey: null,
      editForm: {},
      editFormVisible: false,
      editLoading: false,

      updateStatusFormKey: null,
      updateStatusForm: {},
      updateStatusVisible: false,
      updateStatusLoading: false,
      updateStatusOptions: [
        { name: "卖家未按时发货，扣除保证金", value: "Because you fail to deliver the" },
        { name: "鉴定鞋子假的，扣除保证金", value: "Because your goods judged as fak" },
        { name: "恭喜完成交易", value: "Congratulations on completing th" },
      ],

      importActionUrl: process.env.VUE_APP_MALL_API + "/api/admin/seller-order/import",
      importFormVisible: false,
      importLoading: false,

      statusList: [],

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      productItemTypes: {
        0: "PH Oversea Shipping",
        1: "PH Based Shipping",
        2: "AUS Oversea Shipping",
        3: "AUS Based Shipping",
        4: "MYS Oversea Shipping",
        5: "MYS Based Shipping",
      },
    };
  },
  computed: {
    uploadHeaders() {
      const userToken = getToken();
      const locale = getLocale();
      return {
        "X-User-Token": userToken || "",
        "X-User-Locale": locale || "",
      };
    },
  },
  mounted() {
    this.list();
    this.loadStatusList();
  },
  methods: {
    async loadStatusList() {
      this.statusList = await this.axios.get("mall:/api/admin/seller-order/statusList");
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });

      if (this.filters.timeRange && this.filters.timeRange.length === 2) {
        params.startTime = this.filters.timeRange[0];
        params.endTime = this.filters.timeRange[1];
      }

      try {
        this.results = [];
        const data = await this.axios.form("mall:/api/admin/seller-order/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleCommand(cmd) {
      switch (cmd.type) {
        case "paymentOrder":
          this.handlePaymentOrder(cmd.index, cmd.data);
          break;
        case "updatePrice":
          this.handleEdit(cmd.index, cmd.data);
          break;
        case "updateStatus":
          this.showUpdateStatus(cmd.index, cmd.data);
          break;
        case "showUpdateRecord":
          this.showUpdateRecord(cmd.index, cmd.data);
          break;
      }
    },
    async handlePaymentOrder(index, row) {
      this.$refs.paymentOrderDialog.show("SELLER_ORDER", row.id);
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/seller-order/" + row.id);
        this.editFormKey = new Date().getTime();
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      try {
        await this.axios.form("mall:/api/admin/seller-order/update-price", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    showUpdateStatus(index, row) {
      this.updateStatusVisible = true;
      this.updateStatusFormKey = new Date().getTime();
      this.updateStatusForm.id = row.id;
    },
    updateStatusOptionsChange(value) {
      this.updateStatusForm.memo = value;
    },
    async updateStatus() {
      try {
        await this.axios.form("mall:/api/admin/seller-order/updateStatus", this.updateStatusForm);
        await this.list();
        this.updateStatusForm = {};
        this.updateStatusVisible = false;
        this.$notify.success("Success");
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async showUpdateRecord(index, row) {
      await this.$refs.updateRecord.show(row.id);
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    showImport() {
      this.importFormVisible = true;
    },
    submitImport() {
      if (this.importLoading) {
        return;
      }
      this.importLoading = true;
      try {
        this.$refs.import.submit();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.importLoading = false;
      }
    },
    submitImportError(err, file, fileList) {
      this.$notify.error({ title: "错误", message: err.message || err });
    },
    submitImportSuccess() {
      this.importLoading = false;
      this.importFormVisible = false;
      this.$refs.import.clearFiles();
      this.$notify.success("Sumbit import task success");
    },
  },
};
</script>

<style lang="scss" scoped>
.expand-info {
  margin: 10px;
  .el-descriptions {
    margin-bottom: 10px;
  }
}
</style>
